import React from 'react';

const India = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#D4AF37',
      fontSize: '4rem',
      fontWeight: '700'
    }}>
      hello
    </div>
  );
};

export default India;
